import {Template1} from "../pages/Services/Template1";
import {Template2} from "../pages/Services/Template2";
import {Template3} from "../pages/Services/Template3";
import {Template4} from "../pages/Services/Template4";
import {Template5} from "../pages/Services/Template5";
import {Template6} from "../pages/Services/Template6";
import {Template7} from "../pages/Services/Template7";
import {Template8} from "../pages/Services/Template8";
import {Template9} from "../pages/Services/Template9";
import {Template10} from "../pages/Services/Template10";
import {Template11} from "../pages/Services/Template11";
import {Template12} from "../pages/Services/Template12";
import {Template13} from "../pages/Services/Template13";
import {Template14} from "../pages/Services/Template14";
import {Template15} from "../pages/Services/Template15";
import {Template16} from "../pages/Services/Template16";
import {Template17} from "../pages/Services/Template17";
import {Template18} from "../pages/Services/Template18";
import {Template19} from "../pages/Services/Template19";
import {Template20} from "../pages/Services/Template20";
import {Template21} from "../pages/Services/Template21";
import {Template22} from "../pages/Services/Template22";
import {Template23} from "../pages/Services/Template23";
import {Template24} from "../pages/Services/Template24";
import {Template25} from "../pages/Services/Template25";
import {Template26} from "../pages/Services/Template26";
import {Template27} from "../pages/Services/Template27";
import {Template28} from "../pages/Services/Template28";
import {Template29} from "../pages/Services/Template29";
import {Template30} from "../pages/Services/Template30";
import {Template31} from "../pages/Services/Template31";
import {Template32} from "../pages/Services/Template32";
import {Template33} from "../pages/Services/Template33";
import {Template34} from "../pages/Services/Template34";
import {Template35} from "../pages/Services/Template35";
import {Template36} from "../pages/Services/Template36";
import {Template37} from "../pages/Services/Template37";
import {Template38} from "../pages/Services/Template38";
import {Template39} from "../pages/Services/Template39";
import {Template40} from "../pages/Services/Template40";
import {Template41} from "../pages/Services/Template41";
import {Template42} from "../pages/Services/Template42";
import {Template43} from "../pages/Services/Template43";
import {Template44} from "../pages/Services/Template44";
import {Template45} from "../pages/Services/Template45";
import {Template46} from "../pages/Services/Template46";
import {Template47} from "../pages/Services/Template47";
import {Template48} from "../pages/Services/Template48";
import {Template49} from "../pages/Services/Template49";
import {Template50} from "../pages/Services/Template50";






const loadTemplateComponent = {
  "template-1": Template1,
  "template-2": Template2,
  "template-3": Template3,
  "template-4": Template4,
  "template-5": Template5,
  "template-6": Template6,
  "template-7": Template7,
  "template-8": Template8,
  "template-9": Template9,
  "template-10": Template10,
  "template-11": Template11,
  "template-12": Template12,
  "template-13": Template13,
  "template-14": Template14,
  "template-15": Template15,
  "template-16": Template16,
  "template-17": Template17,
  "template-18": Template18,
  "template-19": Template19,
  "template-20": Template20,
  "template-21": Template21,
  "template-22": Template22,
  "template-23": Template23,
  "template-24": Template24,
  "template-25": Template25,
  "template-26": Template26,
  "template-27": Template27,
  "template-28": Template28,
  "template-29": Template29,
  "template-30": Template30,
  "template-31": Template31,
  "template-32": Template32,
  "template-33": Template33,
  "template-34": Template34,
  "template-35": Template35,
  "template-36": Template36,
  "template-37": Template37,
  "template-38": Template38,
  "template-39": Template39,
  "template-40": Template40,
  "template-41": Template41,
  "template-42": Template42,
  "template-43": Template43,
  "template-44": Template44,
  "template-45": Template45,
  "template-46": Template46,
  "template-47": Template47,
  "template-48": Template48,
  "template-49": Template49,
  "template-50": Template50,









};

export default loadTemplateComponent;